import React from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    MenuItem,
    TextField,
} from '@mui/material';

type FilterState = {
    trailer_no: string;
    product: string;
    rental_company: string;
    lease_agreement_no: string;
    payer: string;
    note: string;
    dclocation: string;
};

type DateState = {
    start_dt?: string;
    end_dt?: string;
};

type Option = {
    label: string;
    value: string;
};

type TrailerFilterModalProps = {
    open: boolean;
    filter: FilterState;
    date: DateState;
    storeOptions: Option[];
    onClose: () => void;
    onFilterChange: (column: keyof FilterState, value: string) => void;
    onDateChange: (key: keyof DateState, value: string) => void;
    onApply: () => void;
    onReset: () => void;
};

const TrailerFilterModal: React.FC<TrailerFilterModalProps> = ({
    open,
    filter,
    date,
    storeOptions,
    onClose,
    onFilterChange,
    onDateChange,
    onApply,
    onReset,
}) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Filters</DialogTitle>

            <DialogContent>
                <Grid container spacing={2} sx={{ mt: 0.5 }}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            fullWidth
                            type="date"
                            label="Start Date"
                            InputLabelProps={{ shrink: true }}
                            value={date?.start_dt || ''}
                            onChange={(e) => onDateChange('start_dt', e.target.value)}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            fullWidth
                            type="date"
                            label="End Date"
                            InputLabelProps={{ shrink: true }}
                            value={date?.end_dt || ''}
                            onChange={(e) => onDateChange('end_dt', e.target.value)}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            fullWidth
                            label="Trailer No"
                            value={filter.trailer_no}
                            onChange={(e) => onFilterChange('trailer_no', e.target.value.toUpperCase())}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            fullWidth
                            label="Product"
                            value={filter.product}
                            onChange={(e) => onFilterChange('product', e.target.value.toUpperCase())}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            fullWidth
                            label="Rental Company"
                            value={filter.rental_company}
                            onChange={(e) => onFilterChange('rental_company', e.target.value.toUpperCase())}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            fullWidth
                            label="Lease Agreement No"
                            value={filter.lease_agreement_no}
                            onChange={(e) =>
                                onFilterChange('lease_agreement_no', e.target.value.toUpperCase())
                            }
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            fullWidth
                            label="Invoice To"
                            value={filter.payer}
                            onChange={(e) => onFilterChange('payer', e.target.value.toUpperCase())}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            fullWidth
                            label="Note"
                            value={filter.note}
                            onChange={(e) => onFilterChange('note', e.target.value.toUpperCase())}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            fullWidth
                            select
                            label="Location"
                            value={filter.dclocation}
                            onChange={(e) => onFilterChange('dclocation', e.target.value)}
                        >
                            {storeOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
                    <Button fullWidth variant="contained" onClick={onApply}>
                        Apply
                    </Button>
                    <Button fullWidth variant="outlined" onClick={onReset}>
                        Reset
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default TrailerFilterModal;